var FetchStatus = /* @__PURE__ */ ((FetchStatus2) => {
  FetchStatus2["FETCHING"] = "FETCHING";
  FetchStatus2["FETCHING_MORE"] = "FETCHING_MORE";
  FetchStatus2["REFETCHING"] = "REFETCHING";
  FetchStatus2["ERROR"] = "ERROR";
  FetchStatus2["FETCHED"] = "FETCHED";
  FetchStatus2["UNINITIALIZED"] = "UNINITIALIZED";
  FetchStatus2["NOT_FOUND"] = "NOT_FOUND";
  return FetchStatus2;
})(FetchStatus || {});
export {
  FetchStatus
};
